module.exports = "<ui-view></ui-view>\n<div id=\"loader\" [ngClass]=\"{hidden: !loaderService.isLoading}\">\n</div>\n"